/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Toast_Account_Needed_TitleInputs */

const en_auth_login_toast_account_needed_title = /** @type {(inputs: Auth_Login_Toast_Account_Needed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account needed`)
};

const pl_auth_login_toast_account_needed_title = /** @type {(inputs: Auth_Login_Toast_Account_Needed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymagane konto`)
};

/**
* | output |
* | --- |
* | "Account needed" |
*
* @param {Auth_Login_Toast_Account_Needed_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_toast_account_needed_title = /** @type {((inputs?: Auth_Login_Toast_Account_Needed_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Toast_Account_Needed_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_toast_account_needed_title(inputs)
	return en_auth_login_toast_account_needed_title(inputs)
});